// Bootstrap
import '../../../BuildEnv/node_modules/bootstrap/js/affix.js';
import '../../../BuildEnv/node_modules/bootstrap/js/alert.js';
import '../../../BuildEnv/node_modules/bootstrap/js/button.js';
import '../../../BuildEnv/node_modules/bootstrap/js/carousel.js';
import '../../../BuildEnv/node_modules/bootstrap/js/collapse.js';
import '../../../BuildEnv/node_modules/bootstrap/js/dropdown.js';
import '../../../BuildEnv/node_modules/bootstrap/js/modal.js';
import '../../../BuildEnv/node_modules/bootstrap/js/tooltip.js';
import '../../../BuildEnv/node_modules/bootstrap/js/popover.js';
import '../../../BuildEnv/node_modules/bootstrap/js/scrollspy.js';
import '../../../BuildEnv/node_modules/bootstrap/js/tab.js';
import '../../../BuildEnv/node_modules/bootstrap/js/transition.js';



// WEBPACK FOOTER //
// ../Resources/Private/JavaScript/bod-libs.js